import { create } from "zustand";

type State = {
  authed: boolean;
  checking: boolean;
  error: string | null;
  login: (password: string) => Promise<void>;
  logout: () => Promise<void>;
  recheck: () => Promise<void>;
};

export const useAuthStore = create<State>((set) => ({
  authed: false,
  checking: false,
  error: null,
  login: async (password) => {
    set({ checking: true, error: null });
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (!res.ok) {
        const msg =
          res.status === 429
            ? "試行回数を超えました。時間を置いてください。"
            : res.status === 401
              ? "パスワードが違います。"
              : `ログインに失敗しました（${res.status}）`;
        set({ checking: false, error: msg, authed: false });
        return;
      }
      set({ checking: false, authed: true, error: null });
    } catch (e) {
      set({
        checking: false,
        error: e instanceof Error ? e.message : "ログインに失敗しました。",
        authed: false,
      });
    }
  },
  logout: async () => {
    try {
      await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
    } catch {
      /* ignore network errors on logout */
    }
    set({ authed: false, error: null });
  },
  recheck: async () => {
    try {
      const res = await fetch("/api/ai/ping", { credentials: "include" });
      set({ authed: res.ok });
    } catch {
      set({ authed: false });
    }
  },
}));
